import React from 'react';

import '../icon-component.scss';

const RenameComponent = () => (
  <svg className="icon-component" viewBox="0 0 20 20">
    <g stroke="none" fill="none">
      <g transform="translate(-1212.000000, -1807.000000)">
        <g transform="translate(1211.605469, 1807.000000)">
          <path d="M1.875,18.369 L5.864,18.369 L18.668,5.565 L14.68,1.576 L1.875,14.38 L1.875,18.369 Z M6.071,19.369 L1.375,19.369 C1.099,19.369 0.875,19.145 0.875,18.869 L0.875,14.173 C0.875,14.04 0.928,13.913 1.021,13.82 L14.326,0.515 C14.514,0.328 14.846,0.328 15.033,0.515 L19.729,5.211 C19.924,5.407 19.924,5.723 19.729,5.918 L6.424,19.223 C6.331,19.316 6.204,19.369 6.071,19.369 L6.071,19.369 Z" />
        </g>
      </g>
    </g>
  </svg>
);

RenameComponent.displayName = 'RenameIcon';

export default RenameComponent;
